import { numberRequiredSchema, select2RequiredSchema, stringRequiredSchema } from "utils/validation/validationHelpers";
import { object } from 'yup';

const addTemplateSchema = object().shape({

    template_id: numberRequiredSchema,
    subject: stringRequiredSchema,
    template_desc: stringRequiredSchema,
    email_heading: stringRequiredSchema,
    email_content: stringRequiredSchema,
    email_status: select2RequiredSchema,
    firebase_status: stringRequiredSchema,
    notification_type: select2RequiredSchema
});

export default addTemplateSchema;